// Import slider images
import slider1 from '../images/slider/slider_1.png';
import slider2 from '../images/slider/slider_2.png';
import slider3 from '../images/slider/slider_3.png';
import slider4 from '../images/slider/slider_4.png';
import slider5 from '../images/slider/slider_5.png';
import buddha1 from '../images/budha/budha_1.png';
import buddha2 from '../images/budha/budha_2.png';
import buddha3 from '../images/budha/budha_3.png';
import buddha4 from '../images/budha/budha_4.png';
import buddha5 from '../images/budha/budha_5.png';
import buddha6 from '../images/budha/buddha_6.png';

// Import god images
import god1 from '../images/god/god_1.png';
import god2 from '../images/god/god_2.png';
import god3 from '../images/god/god_3.png';
import god4 from '../images/god/god_4.png';
import god5 from '../images/god/god_5.png';
import god6 from '../images/god/god_6.png';
import god7 from '../images/god/god_7.png';
import god8 from '../images/god/god_8.png';
import god9 from '../images/god/god_9.png';


// import life images
import life1 from '../images/life/life_1.png';
import life2 from '../images/life/life_2.png';
import life3 from '../images/life/life_3.png';
import life4 from '../images/life/life_4.png';
import life5 from '../images/life/life_5.png';
import life6 from '../images/life/life_6.png';
import life7 from '../images/life/life_7.png';
import life8 from '../images/life/life_8.png';
import life9 from '../images/life/life_9.png';
import life10 from '../images/life/life_10.png';

//mural
import mural1 from '../images/mural/mural_1.png';
import mural2 from '../images/mural/mural_2.png';
import mural3 from '../images/mural/mural_3.png';
import mural4 from '../images/mural/mural_4.png';
import mural5 from '../images/mural/mural_5.png';
import mural6 from '../images/mural/mural_6.png';
import army1 from '../images/army/army_1.png';
import army2 from '../images/army/army_2.png';
import army3 from '../images/army/army_3.png';
import army4 from '../images/army/army_4.png';
import army5 from '../images/army/army_5.png';
import army6 from '../images/army/army_6.png';
import army7 from '../images/army/army_7.png';
import army8 from '../images/army/army_8.png';
import army9 from '../images/army/army_9.png';
import army10 from '../images/army/army_10.PNG';

// Slider images - imported from src/images/slider
export const sliderImages = [
  slider1,
  slider2,
  slider3,
  slider4,
  slider5
];

// All artworks in a single array - no categories
export const artworkImages = [
  // Buddha artworks
  {
    image: buddha1,
    title: 'Golden Buddha',
    description: 'A serene representation of Buddha in meditation, capturing the essence of inner peace.'
  },
  {
    image: buddha2,
    title: 'Buddha in Lotus',
    description: 'Buddha seated in lotus position, surrounded by symbolic elements of enlightenment.'
  },
  {
    image: buddha3,
    title: 'Tara Statue'
  },
  {
    image: buddha4,
    title: 'Jizo Statue'
  },
  {
    image: buddha5,
    title: 'Meditating Buddha',
    description: 'Soft watercolor technique depicting Buddha in deep meditation.'
  },
  {
    image: buddha6,
    title: 'Meditating Buddha',
    description: 'Soft watercolor technique depicting Buddha in deep meditation.'
  },
  // God artworks
  {
    image: god1,
    title: 'Ram Lala'
  },
  {
    image: god2,
    title: 'Ram Ji Statue'
  },
  {
    image: god3,
    title: 'Saraswati statue'
  },
  {
    image: god4,
    title: 'Ganesh Statue'
  },
  {
    image: god5,
    title: 'Radha Krishna'
  },
  {
    image: god6,
    title: 'Krishna'
  },
  {
    image: god7,
    title: 'Lord Hanuman Statue'
  },
  {
    image: god8,
    title: 'Ram ji'
  },
  {
    image: god9,
    title: 'Ram ji'
  },
  // Mural artworks
  {
    image: mural1,
    title: 'Lord Krishna with Geeta Updesh to Arjun Mahabharat'
  },
  {
    image: mural2,
    title: 'Colorful butterfly with orange/yellow upper wings and purple/blue lower wings'
  },
  {
    image: mural3,
    title: '7 horses wall art'
  },
  {
    image: mural4,
    title: '3D Buddha Mural'
  },
  {
    image: mural5,
    title: '3D Horse Mural'
  },
  {
    image: mural6,
    title: 'Lord Krishna with Geeta Updesh to Arjun Mahabharat',
    description: 'Mural representing the teachings of Lord Krishna to Arjun in the Bhagavad Gita.'
  },
  // Life artworks
  {
    image: life1,
    title: 'Indira Gandhi Statue'
  },
  {
    image: life2,
    title: 'Life Statue'
  },
  {
    image: life3,
    title: 'Shiva Ji'
  },
  {
    image: life4,
    title: 'Shiva Ji Maharaj',
    description: 'Soft watercolor technique depicting Shiva Ji in a majestic pose.',
    location: 'Penglong Lake, India'
  },
  {
    image: life5,
    title: 'Statue',
  },
  {
    image: life6,
    title: 'Life Statue'
  },
  {
    image: life7,
    title: 'Atal Bihari Vajpayee Statue'
  },
  {
    image: life8,
    title: 'Gandhi ji'
  },
  {
    image: life9,
    title: 'Gandhi ji',
    location: 'vikas bhawan ambedkar nagar, UP, India'
  },
  {
    image: life10,
    title: 'Statue'
  },
  // Army artworks
  {
    image: army1,
    title: 'Padma Vibhushan Field Marshal Sam Manekshaw'
  },
  {
    image: army2,
    title: 'Soldier Statue'
  },
  {
    image: army3,
    title: '1971 Liberation War of Bangladesh: Battle of Garibpur'
  },
  {
    image: army4,
    title: 'They are raising the Indian national flag (Tricolour), which represents unity, victory, and national pride.',
    location: 'Jhansi Cantt, UP, India'
  },
  {
    image: army5,
    title: 'Army Statue'
  },
  {
    image: army6,
    title: 'Late Colonel MN Rai'
  },
  {
    image: army7,
    title: 'Late Captain Manoj Pandey'
  },
  {
    image: army8,
    title: 'Bust Sculptures'
  },
  {
    image: army9,
    title: '3D Army Sculpture',
    location: 'Core HQ, Jalandhar, PB, India'
  },
  {
    image: army10,
    title: 'Shiva Ji',
    location: 'Kanpur Cantt, UP, India'
  }
];

// In production, use relative URLs (empty string) so API calls go to the same
// origin as the page — this avoids CORS entirely. In local dev, point to the
// PHP built-in server running on port 8000.
export const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? ''
    : 'http://localhost:8000');

export const getImageUrl = (imagePath) => {
  if (!imagePath) return '/images/placeholder.jpg';
  if (typeof imagePath !== 'string') return imagePath;
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('data:')) {
    return imagePath;
  }
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${API_BASE_URL}${cleanPath}`;
};

// Function to get all artworks (merged static and uploaded)
export const getAllArtworks = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/artworks`);
    if (!response.ok) throw new Error('Failed to fetch uploaded artworks');
    const uploadedArtworks = await response.json();

    // Process uploaded artworks to have absolute/correct image URLs
    const processedUploaded = uploadedArtworks.map(art => ({
      ...art,
      image: getImageUrl(art.image),
      id: art.id // Keep the backend ID
    }));

    // Return merged list (uploaded first)
    return [...processedUploaded, ...artworkImages];
  } catch (error) {
    console.error('Error fetching artworks:', error);
    return artworkImages; // Fallback to static images only
  }
};

// Categorized artworks for the gallery sections
export const getCategorizedArtworks = async () => {
  const allArtworks = await getAllArtworks();

  const categorized = {
    'Army Sculptures': allArtworks.filter(item =>
      (item.category === 'Army Sculptures') ||
      (item.image && typeof item.image === 'string' && item.image.toLowerCase().includes('army'))
    ),
    'Buddha Sculptures': allArtworks.filter(item =>
      (item.category === 'Buddha Sculptures') ||
      (item.image && typeof item.image === 'string' && item.image.toLowerCase().includes('budha'))
    ),
    'Divine Sculptures': allArtworks.filter(item =>
      (item.category === 'Divine Sculptures') ||
      (item.image && typeof item.image === 'string' && item.image.toLowerCase().includes('god'))
    ),
    'Human Sculptures': allArtworks.filter(item =>
      (item.category === 'Human Sculptures') ||
      (item.image && typeof item.image === 'string' && item.image.toLowerCase().includes('life'))
    ),
    'Wall Murals': allArtworks.filter(item =>
      (item.category === 'Wall Murals') ||
      (item.image && typeof item.image === 'string' && item.image.toLowerCase().includes('mural'))
    ),
    'Elevation Art': allArtworks.filter(item =>
      (item.category === 'Elevation Art') ||
      (item.image && typeof item.image === 'string' && item.image.toLowerCase().includes('elevation'))
    ),
    'Life Sculpture': allArtworks.filter(item =>
      (item.category === 'Life Sculpture') ||
      (item.image && typeof item.image === 'string' && item.image.toLowerCase().includes('life'))
    ),
    'Animal Sculpture': allArtworks.filter(item =>
      (item.category === 'Animal Sculpture') ||
      (item.image && typeof item.image === 'string' && item.image.toLowerCase().includes('animal'))
    )
  };

  return categorized;
};

export const CATEGORIES = [
  'Army Sculptures',
  'Buddha Sculptures',
  'Divine Sculptures',
  'Human Sculptures',
  'Wall Murals',
  'Elevation Art',
  'Life Sculpture',
  'Animal Sculpture'
];

